import { api } from "./configs/axiosConfigs"

export const ShoppingCartAPI = {
    
    getShoppingCart: async (data:any) => {
        const response = await api.get(
            '/shoppingCart', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getCountShoppingCart: async (iduser: number, data:any) => {
        const response = await api.get(
            `/shoppingCart/${iduser}`, { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createShoppingCart: async (data: any) => {
        const response = await api.post(
            '/shoppingCart/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editCartProduct: async (idproduct: number, data: any) => {
        const response = await api.patch(
            `/shoppingCart/updateProduct/${idproduct}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteProductCart: async (idproduct: number) => {
        const response = await api.delete(
            `/shoppingCart/deleteProduct/${idproduct}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    changeGlobalDiscount: async (idcart: number, data: any) => {
        const response = await api.patch(
            `/shoppingCart/discountGlobal/${idcart}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    assignCustomer: async (idcart: number, data: any) => {
        const response = await api.patch(
            `/shoppingCart/assignCustomer/${idcart}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}